module.exports = __webpack_public_path__ + "static/img/four.0191514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wardrobeImg/four.png
// module id = sf/v
// module chunks = 1